import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";

import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

export default class AddTeam extends Component {
  state = {
    name: "",
    position: "",
    description: "",
    image: null, // file
    status: "active",
    is_delete: "no",

    message: "",
    notification: false,
    notiColor: "success",
    redirect: false,
    loading: false,
  };

  handleInput = (e) => {
    if (e.target.name === "image") {
      this.setState({ image: e.target.files[0] });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { name, position, description, image, status, is_delete } = this.state;

    // Basic validation (you can relax this if not needed)
    if (!name) {
      this.setState({
        notification: true,
        notiColor: "warning",
        message: "Name is required!",
      });
      setTimeout(() => this.setState({ notification: false, message: "" }), 3000);
      return;
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const fd = new FormData();
    fd.append("name", name);
    fd.append("position", position);
    fd.append("description", description);
    fd.append("status", status);
    fd.append("is_delete", is_delete);
    if (image) fd.append("client_image", image); // backend expects client_image

    this.setState({ loading: true });

    axios
      .post(Constants.postUrls.createTeam, fd)
      .then((resp) => {
        this.setState({
          notification: true,
          notiColor: "success",
          message: resp.data?.message || "Team member created!",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "", redirect: true }), 1800);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to create team member",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 4000);
      });
  };

  render() {
    if (this.state.redirect) return <Navigate to="/teams" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Add Team Member
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <TextField
                      type="text"
                      label="Name"
                      name="name"
                      onChange={this.handleInput}
                      value={this.state.name}
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      type="text"
                      label="Position"
                      name="position"
                      onChange={this.handleInput}
                      value={this.state.position}
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      type="file"
                      label="Profile Image"
                      name="image"
                      focused
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Select Status</InputLabel>
                    <Select
                      value={this.state.status}
                      onChange={(e) => this.setState({ status: e.target.value })}
                      name="status"
                      style={{ width: "100%", height: "45px", color: "#fff" }}
                    >
                      <MenuItem value="active" style={{ color: "#fff" }}>
                        Active
                      </MenuItem>
                      <MenuItem value="inactive" style={{ color: "#fff" }}>
                        Inactive
                      </MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      type="text"
                      label="Description"
                      name="description"
                      onChange={this.handleInput}
                      value={this.state.description}
                      style={{ width: "100%" }}
                      multiline
                      rows={4}
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <MDButton variant="contained" size="small" color="info" type="submit">
                      {this.state.loading ? "Creating..." : "Create"}
                    </MDButton>
                  </Grid>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Teams Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
